import _ from "lodash";
import { VITALLY_NPS } from "Constants";

const loadVitally = async () => {
  var load = function () {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "vitally-snippet";
    script.defer = true;
    script.src = VITALLY_NPS.url;
    document.getElementsByTagName("head")[0].appendChild(script);
  };

  var loadVitallyScript = function () {
    (function (n, t, r) {
      for (
        var i = (n[t] = n[t] || []),
          o = function (r) {
            i[r] =
              i[r] ||
              function () {
                for (var n = [], t = 0; t < arguments.length; t++)
                  n[t] = arguments[t];
                return i.push([r, n]);
              };
          },
          u = 0,
          c = ["init", "user", "account", "nps"];
        u < c.length;
        u++
      ) {
        o(c[u]);
      }
    })(window, "Vitally");
    window.Vitally.init(VITALLY_NPS.token);
  };
  load();
  loadVitallyScript();
};

const identifyVitallyAccount = async payload => {
  if (!validateVitallyNpsPayload(payload)) {
    return;
  }

  const { orgId = "", orgName = "", id = "" } = payload;
  const data = await window.Vitally.account({
    accountId: orgId,
    traits: {
      name: orgName,
    },
  });
  await window.Vitally.user({
    userId: id,
    accountId: orgId,
    traits: buildUserTraits(payload),
  });
  await activateVitally();
};

const activateVitally = async () => {
  await window.Vitally.nps("survey", {
    productName: "Toddle",
    delay: 1000,
    primaryColor: "#D33752",
    npsQuestion:
      "Help us make Toddle better for you. On a scale of 0-10, how likely are you to recommend it to fellow educators?",
    followUpTitle: "Thank you.",
    followUpSubtitle: "What is the primary reason for your response?",
  });
};

const validateVitallyNpsPayload = payload => {
  const { orgId, id } = payload;
  return !_.isEmpty(orgId) && !_.isEmpty(id);
};

const buildUserTraits = payload => {
  const {
    firstName = "",
    lastName = "",
    email = "",
    firstLoggedInAt = "",
  } = payload;
  const traits = {
    name: userNameBuilder({ firstName, lastName }),
    email: email,
  };

  if (!_.isEmpty(firstLoggedInAt)) {
    const firstLoggedInDate = _.split(firstLoggedInAt, "T")[0];
    if (!_.isEmpty(firstLoggedInDate)) {
      traits.createdAt = firstLoggedInDate;
    }
  }
  return traits;
};

const userNameBuilder = data => {
  const { firstName, lastName } = data;
  const parts = [];

  if (_.isString(firstName) && !_.isEmpty(firstName)) {
    parts.push(firstName);
  }

  if (_.isString(lastName) && !_.isEmpty(lastName)) {
    parts.push(lastName);
  }

  return parts.join(" ");
};

export { loadVitally, identifyVitallyAccount, activateVitally };
